export default {
  noBookings: {
    title: 'Events',
    description: 'You have no events',
    date: 'd.',
    createBooking: 'Create a booking'
  }
}